// Mirrors GC\PackagingOption\Entity\PackagingOptionInterface and
// PackagingOptionGroupInterface so no raw DB enum values live in components.
export const CostingMethod = {
    PERCENTAGE: 1,
    FIXED_JOB: 2,
    FIXED_PRODUCT: 3,
    BY_DISTANCE: 4,
    TO_BE_QUOTED: 5,
};

export const PriceType = {
    FLAT: 1,
    INDICATIVE: 2,
};

export const OptionAvailability = {
    PICKUP: 1,
    DELIVERY: 2,
    PICKUP_AND_DELIVERY: 3,
};

export const GroupSelectionMode = {
    REQUIRED: 1,
    OPTIONAL: 2,
    ANY: 3,
};

export const GroupCategory = {
    FREIGHT: 1,
    PACKAGING: 2,
    SERVICE: 3,
};
